import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { exerciseUrls, roles } from '../../common/config'
import { setAfterAuthRedirect } from '../../common/app/actions'
import { loadLessons, hideHomeworkForm } from '../../common/lessons/actions'
import { createHomework, setCurrentHomework } from '../../common/homeworks/actions'
import { setUserInfo, signUp } from '../../common/users/actions'
import { Button } from '../components'
import { SignUpForm } from '../forms'

class HomeworkPopup extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      copiedLink: false,
    }
  }

  componentDidCatch(error, info) {
    console.log('error - HomeworkPopup')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentDidMount() {
    const { setUserInfo, viewer, currentLesson,
      createHomework, setAfterAuthRedirect } = this.props
    
    if (!viewer) {
      setUserInfo({ 'role': roles.TEACHER })

      createHomework({
        name: `${currentLesson.name} - homework`,
        lessons: [currentLesson.id],
      })

      setAfterAuthRedirect(`/lessons/${currentLesson.id}`)
    }
  }

  copyText() {
    this.linkText.focus()
    this.linkText.select()
    this.linkText.setSelectionRange(0, 99999)

    document.execCommand('copy')

    this.setState({ copiedLink: true })
  }

  render() {
    const { intl, signUp, viewer, hideHomeworkForm,
      currentHomework, currentLesson } = this.props

    const { copiedLink } = this.state
    
    let homeworkLink = ''

    if (currentHomework && currentHomework.homeworkId) {
      homeworkLink = `vobo.io/homework/${currentHomework.homeworkId}`
    }

    return (
      <div className="popup-wrapper">
        <div className="popup-content">
          <header>
            <div
              className="popup-wrapper-close"
              onClick={() => hideHomeworkForm()}
            >
              <FontAwesomeIcon icon="times-circle" size="2x" />
            </div>
          </header>
          <div className="popup-content-body homework-popup">
          {
            (viewer && currentHomework) ?
              <div>
                <h3>
                  {intl.formatMessage(messages.homeworkIsReady)}
                </h3>
                <div className="homework-popup-message">
                  <span>{intl.formatMessage(messages.homeworkLink)}</span>
                  <a target="_blank" rel="noopener noreferrer" href={`/homework/${currentHomework.homeworkId}`}>
                    <textarea
                      id="homework-popup-link"
                      autocomplete="off"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      data-gramm="false"
                      ref={el => this.linkText = el}
                      value={homeworkLink}
                    /> 
                  </a>
                  <Button
                    positive
                    onClick={() => this.copyText()}
                  >
                    {intl.formatMessage(messages.copyLink)}
                  </Button>
                </div>
                {
                  copiedLink &&
                  <p className="green-text">
                    {intl.formatMessage(messages.linkCopied)}
                  </p>
                }
                <p className="highlighted-text">
                  {intl.formatMessage(messages.sendLink)}
                </p>
                <Link
                  id="results-link" to={`/app/homework/${currentHomework.id}`}
                  onClick={() => hideHomeworkForm()}
                >
                  {intl.formatMessage(messages.resultsLink)}
                </Link>
              </div>
            :
              <React.Fragment>
                <img
                  className="tutorial-image"
                  src="/assets/images/homework-tutorial.png"
                />
                <div className="homework-popup-sign-up">
                  <h3>
                    {intl.formatMessage(messages.title)}
                  </h3>
                  <SignUpForm signUp={signUp} />
                  <p>
                    {intl.formatMessage(messages.alreadyRegistered)}<br />
                    <Link to={`/sign-in?/lessons/${currentLesson.id}`}><b>{intl.formatMessage(messages.signIn)}</b></Link>
                  </p>
                </div>
              </React.Fragment>
          }
          </div>
        </div>
      </div>
    )
  }
}


HomeworkPopup.defaultProps = {
}

HomeworkPopup.propTypes = {
  setUserInfo: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
  createHomework: PropTypes.func.isRequired,
  setCurrentHomework: PropTypes.func.isRequired,
  hideHomeworkForm: PropTypes.func.isRequired,
}

const enhance = compose(
  connect((state) => ({
    currentLesson: state.lessons.currentLesson,
    currentHomework: state.homeworks.currentHomework,
    viewer: state.users.viewer,
  }),
  { setUserInfo, signUp, createHomework, setAfterAuthRedirect, setCurrentHomework, hideHomeworkForm }),
  injectIntl,
)

export default enhance(HomeworkPopup)

const messages = defineMessages({
  title: {
    id: 'homework.popup.title',
    defaultMessage: 'Zaregistrujte sa aby ste mali prístup k vyplneným úlohám.',
  },
  homeworkIsReady: {
    id: 'homework.popup.homeworkIsReady',
    defaultMessage: 'Domáca úloha je pripravená',
  },
  homeworkLink: {
    id: 'homework.popup.homeworkLink',
    defaultMessage: 'Link pre žiakov na vyplnenie domácej úlohy: ',
  },
  resultsLink: {
    id: 'homework.popup.resultsLink',
    defaultMessage: 'Prejsť na stránku s výsledkami',
  },
  copyLink: {
    id: 'homework.popup.copyLink',
    defaultMessage: 'Skopírovať link',
  },
  linkCopied: {
    id: 'homework.popup.linkCopied',
    defaultMessage: 'Link bol skopírovaný.',
  },
  sendLink: {
    id: 'homework.popup.sendLink',
    defaultMessage: 'Pošlite tento link žiakom aby mohli vypracovať domácu úlohu.',
  },
  alreadyRegistered: {
    id: 'homework.popup.alreadyRegistered',
    defaultMessage: 'Máte už vytvorený učet?',
  },
  signIn: {
    id: 'homework.popup.signIn',
    defaultMessage: 'Prihlásiť sa',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/HomeworkPopup.js